{
  "nl": {
    "textEditor": {
      "editKinds": {
        "help_me_write": "Schrijfhulp",
        "spellcheck": "Spelling",
        "summarize": "Samenvatten",
        "translate": "Vertalen"
      },
      "headers": {
        "aiTextModal": "AI-Assistentie: {title}"
      },
      "hints": {
        "loadingDocument": "Document wordt geladen...",
        "noTextSelected": "Geen tekst geselecteerd",
        "progressMessage": "Bewerking wordt uitgevoerd...",
        "prompt": "Bijvoorbeeld: <strong>Bundesländer in Deutschland</strong> of <strong>Rom der Antike</strong>"
      },
      "links": {
        "helpMeWrite": "Help me schrijven",
        "spellcheck": "Spelling & grammatica corrigeren",
        "summarize": "Samenvatten",
        "translate": "Vertalen"
      },
      "placeholder": "Maak samen teksten met verschillende media-inhoud zoals opgemaakte tekst, afbeeldingen en externe links.",
      "placeholders": {
        "aiPromptModal": "Onderwerp invoeren..."
      }
    }
  }
}
